const socialNetworks = [
  {
    icon: '/icons/social/vk.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_VK
  },
  {
    icon: '/icons/social/telegram.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_TELEGRAM
  },
  {
    icon: '/icons/social/instagram.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_INSTAGRAM
  },
  {
    icon: '/icons/social/facebook.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_FACEBOOK
  },
  {
    icon: '/icons/social/tik-tok.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_TIKTOK
  },
  {
    icon: '/icons/social/max.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_MAX
  }
]

const supportMessengers = [
  {
    icon: '/icons/social/telegram.svg',
    url: import.meta.env.VITE_SUPPORT_TELEGRAM,
    name: 'Telegram'
  },
  {
    icon: '/icons/social/whatsapp.svg',
    url: import.meta.env.VITE_SUPPORT_WHATSAPP,
    name: 'WhatsApp'
  },
  {
    icon: '/icons/social/max.svg',
    url: import.meta.env.VITE_SUPPORT_MAX,
    name: 'Max'
  }
]

export const SOCIAL = socialNetworks.filter(network => network.url)
export const SUPPORT_MESSENGERS = supportMessengers.filter(messenger => messenger.url)